import { render, staticRenderFns } from "./SalesReportsNeopag.vue?vue&type=template&id=1d8c68a7&"
import script from "./SalesReportsNeopag.vue?vue&type=script&lang=js&"
export * from "./SalesReportsNeopag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports